/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free number-to-words converter. Spell out any whole number in English words for cheques, invoices and forms. Runs in your browser.`)
};

const es_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor gratuito de números a palabras. Deletrea cualquier número entero en palabras inglesas para cheques, facturas y formularios. Se ejecuta en tu navegador.`)
};

const de_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zahlen-in-Worte-Konverter. Schreiben Sie jede ganze Zahl in englischen Worten aus — für Schecks, Rechnungen und Formulare. Läuft direkt in Ihrem Browser.`)
};

const nl_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis getal-naar-woorden omzetter. Schrijf elk heel getal uit in Engelse woorden voor cheques, facturen en formulieren. Werkt in uw browser.`)
};

const fr_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit de nombres en lettres. Écrivez n'importe quel nombre entier en toutes lettres pour les chèques, factures et formulaires. Fonctionne dans votre navigateur.`)
};

const it_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore gratuito da numeri a parole. Scrivi qualsiasi numero intero in parole inglesi per assegni, fatture e moduli. Funziona nel tuo browser.`)
};

const pt_br2_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de números em palavras. Escreva qualquer número inteiro em palavras em português para cheques, notas fiscais e formulários. Funciona no seu navegador.`)
};

const pt_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de números para palavras. Escreva qualquer número inteiro em palavras inglesas para cheques, faturas e formulários. Funciona no seu navegador.`)
};

const ja_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の数字を単語に変換するツール。小切手、請求書、フォームなど、任意の整数を英語の単語で綴ることができます。ブラウザで実行されます。`)
};

const zh_nw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的数字转文字转换器。将任意整数用英文单词拼写出来，适用于支票、发票和表格。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_tool_description", locale)
	if (locale === "en") return en_nw_tool_description(inputs)
	if (locale === "es") return es_nw_tool_description(inputs)
	if (locale === "de") return de_nw_tool_description(inputs)
	if (locale === "nl") return nl_nw_tool_description(inputs)
	if (locale === "fr") return fr_nw_tool_description(inputs)
	if (locale === "it") return it_nw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_nw_tool_description(inputs)
	if (locale === "pt") return pt_nw_tool_description(inputs)
	if (locale === "ja") return ja_nw_tool_description(inputs)
	return zh_nw_tool_description(inputs)
};